import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import LModal from '@max/leez-modal';
import LText from '@max/leez-text';
import { setRemConfig } from '@max/leez-style-util';
import { hotelTheme } from '@max/leez-theme-hotel';
import { setCustomTheme } from '@max/leez-context';
import View from '@hfe/max-view';
setCustomTheme(hotelTheme);
setRemConfig({
    enabled: true
});
export function useConfirm() {
    const ctx = useMonitorEngineContext();
    const { fullScreenHeight } = getFullScreenSize();
    function openConfirm(options) {
        const ConfirmPanel = <LModal visible={true} title={options.title} style={{
            width: '564rpx'
        }} contentContainerStyle={{
            paddingLeft: '34rpx',
            paddingRight: '34rpx'
        }}>
      <View style={{
            width: '100%'
        }}>
        <LText style={{
            textAlign: 'center'
        }} type="body2">
          {options.content}
        </LText>
        <View style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row',
            marginTop: '60rpx'
        }}>
          <View onClick={options.onCancel} style={{
            backgroundColor: '#f0f0f0',
            width: '238rpx',
            height: '96rpx',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '48rpx'
        }}>
            <LText style={{
            color: '#c2c2c2',
            fontSize: '36rpx',
            lineHeight: '48rpx',
            fontWeight: '600'
        }}>取消</LText>
          </View>
          <View onClick={options.onConfirm} style={{
            backgroundColor: '#ffe74d',
            width: '238rpx',
            height: '96rpx',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '48rpx'
        }}>
            <LText style={{
            color: '#111111',
            fontSize: '36rpx',
            fontWeight: '600',
            lineHeight: '48rpx'
        }}>确认</LText>
          </View>
        </View>
      </View>
    </LModal>;
        ctx._topPanelAPI.setPanelHeight(fullScreenHeight);
        ctx._topPanelAPI.setContent(ConfirmPanel);
        ctx._topPanelAPI.setVisible({
            visible: true
        });
    }
    function closeConfirm() {
        ctx._topPanelAPI.setContent(null);
        ctx._topPanelAPI.setVisible({
            visible: false
        });
    }
    return {
        openConfirm,
        closeConfirm
    };
}
